import { PropTypes } from 'prop-types';
import useLabels from 'infrastructure/js/hooks/useLabels';
import withPortal from 'infrastructure/js/components/HOCs/withPortal/withPortal';
import Combobox from 'infrastructure/js/components/controls/Combobox/combobox.js';
import Button from 'infrastructure/js/components/controls/Button/button';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';

import './sensorsListItem.scss';

const ComboboxPortal = withPortal(Combobox);

export default function SensorsListItem({
  sensorIntegration,
  name,
  options,
  onChangeCallback,
  onSensorChange,
  index,
  actions,
  sData,
  values,
  change,
  sensorIntegrationErrorDialogBuilder,
}) {
  const labels = useLabels('mat.locationpage.view.shipments.shipToCustomer.dialog.sensorsListItem.');

  const onSensorChanged = (value, oldValue) => {
    onChangeCallback?.(value, oldValue, index);
    onSensorChange();

    const prevSensorId = oldValue?.value;
    const prevSensorConnected = values.isConnected;
    if (!prevSensorId || !prevSensorConnected) return;

    const shipmentId = sData.get('preselectedAssets').get(0)?.id;
    actions.unAssignSensorFromShipment(shipmentId, prevSensorId, sensorIntegrationErrorDialogBuilder());
    change(name + '.[isConnected]', false);
  };

  const onConnectClick = () => {
    const data = {
      shipmentId: sData.get('preselectedAssets').get(0)?.id,
      sensorId: values.sensor?.value,
    };

    actions.assignSensorToShipment(data, sensorIntegrationErrorDialogBuilder()).then(({ success }) => {
      if (success) {
        change(name + '.[isConnected]', true);
      }
    });
  };

  return (
    <div className="sensors-list-item">
      <ComboboxPortal
        id={name + '.[sensor]'}
        name={name + '.[sensor]'}
        options={options}
        change={change}
        onChangeCallback={onSensorChanged}
        validate={sensorIntegration && Validation.required}
        isDisabled={!sensorIntegration}
      />
      <Button
        id={name + '.[connect]'}
        bsStyle="default"
        className="connect-btn border-btn"
        disabled={!sensorIntegration || !values.sensor?.value || values.isConnected}
        onClick={onConnectClick}
      >
        {labels.get('connect')}
      </Button>
    </div>
  );
}

SensorsListItem.propTypes = {
  sensorIntegration: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChangeCallback: PropTypes.func,
  onSensorChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  sensorIntegrationErrorDialogBuilder: PropTypes.func.isRequired,
};